module.exports = __webpack_public_path__ + "assets/oppsite-arrow.041fb43d.svg";